import { useState, useEffect, useContext, useRef } from 'react';

import { cmnContext } from '../../../../../common/CmnContext';
import { SaleListContext } from '../../../SaleListContext';


export function SaleListDetailPurchaseTicket(props: any) {

  const sale = props.sale;
  const isPlus = props.isPlus;

  const isPc = useContext(cmnContext).isPc;

  const {
    user,
    telecomUrl, telecomTag,
    TELECOM_CLIENTIP, BASE_URL_SSL,
  }= useContext(SaleListContext);


  const btnWrap = {
    flex: isPc? 1 : 'none',
    width: '100%',
    margin: isPc? '10px 20px' : 5,
  };


  return (
    <div
      className="text-center"
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: isPc? 'row' : 'column',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
      }}
    >

      {/* チケット */}
      {sale.ticket > 0 &&
        <div style={btnWrap}>
          <form action="/sale/sale_request" method="post">
            <input className="sale_id" type="hidden" name="sale_id" value={sale.id} />
            <input type="hidden" name="mode" value="regist" />
            <button
              type="submit"
              id="ticket_submit"
              name="submit"
              value="交換"
              className="btn btn-warning btn-block btn_customize"
              style={{
                padding: (!isPc && isPlus)? '5px 8px' : '10px 15px',
              }}
              onClick={(e) => {
                // 確認ダイアログ
                if (!window.confirm('この動画と交換します。よろしいですか？')) {
                  e.preventDefault(); // キャンセル時は submit を止める
                  return false;
                }
              }}
            >
              交換 ({sale.ticket}チケット) <span className="disp_ticket"></span><i className="fas fa-chevron-circle-right"></i>
            </button>
          </form>
        </div>
      }

      {/* クレカ */}
      {sale.price > 0 &&
        <div style={btnWrap}>
          <form className="form-inline" method="post" action={`//secure.telecomcredit.co.jp/inetcredit/secure/${telecomUrl}`}>
            <input type="hidden" name="clientip" value={TELECOM_CLIENTIP}/>
            <input type="hidden" name="us" value={user.id}/>
            <input type="hidden" name="usrmail" value={user.email}/>
            <input type="hidden" className="redirect_back_url" name="redirect_back_url" value={`${BASE_URL_SSL}sale/sale_complete`} />
            <input type="hidden" className="sell_type" name="sell_type" value={`53_${sale.id}`} />
            <input type="hidden" className="money" name="money" value={sale.price}/>
            <div dangerouslySetInnerHTML={{ __html: telecomTag }} />
            <button
              type="submit"
              name="submit"
              value="購入"
              className="btn btn-success btn-block btn_customize"
              style={{
                padding: (!isPc && isPlus)? '5px 8px' : '10px 15px',
              }}
            >
              購入 (¥{sale.price.toLocaleString()}) <span className="disp_price"></span><i className="fas fa-chevron-circle-right"></i>
            </button>
          </form>
        </div>
      }

    </div>
  );
}